import { useFilterContext } from "../context/FilterContext";
import FormatPrice from "../helper/FormatPrice";

const FilterSection = () => {
    const {
        filters: { shape, carat, price, maxPrice, minPrice, color },
        updateFilterValue,
        all_products,
    } = useFilterContext();

    // get the unique values of each property
    const getUniqueData = (data, attr) => {
        let newVal = data.map((curElem) => {
            return curElem[attr];
        });

        return (newVal = ["all", ...new Set(newVal)]);
    };

    // we need to have the individual data of each in an array format
    const shapeData = getUniqueData(all_products, "shape");
    const caratData = getUniqueData(all_products, "carat");
    const colorData = getUniqueData(all_products, "color");
    // console.log(
    //   "🚀 ~ file: FilterSection.js ~ line 23 ~ FilterSection ~ caratData",
    //   shapeData
    // );

    // const FilterSection1 = () => {
    //     var inputValue = document.getElementById("inputRange").value;
    //     var options = document.querySelectorAll("#tickmarks").childNodes;

    //     let text = "";
    //     for (let i = 0; i < options.length; i++) {
    //         text += options[i].nodeName + "<br>";
    //     }
    //     document.getElementById("demo").innerHTML = text;

    //     console.log(inputValue);
    //     // console.log(newCol);
    //     console.log(options);
    // }
    return (
        <>
            {/* <div className="filter-shape mb-2">
                <div className='range-slider'>
                    <p id="demo">{colorData.value}</p>
                    <input type="range" list="tickmarks" id="inputRange" step="1" min="0" value={color} max={colorData.length} onChange={FilterSection1} />
                    <datalist id="tickmarks">
                        {colorData.map((curElem, index) => {
                            return (
                                <>
                                    <option
                                        key={index}
                                        name="color"
                                        data-value={index}
                                        value={curElem}
                                        className="inputRangeDataOpt"
                                    >
                                        {curElem}
                                    </option>
                                </>
                            );
                        })
                        }
                    </datalist>
                </div>
            </div> */}


            <div className="filter-shape mb-2">

                <h3>Shape</h3>
                <ul>
                    {shapeData.map((curElem, index) => {
                        return (
                            <button
                                key={index}
                                type="button"
                                name="shape"
                                value={curElem}
                                className={curElem === shape ? "active" : ""}
                                onClick={updateFilterValue}>
                                {curElem}
                            </button>
                        );
                    })}
                </ul>
            </div>

            <div className="filter-shape mb-2">
                <h3>Carat</h3>
                <div>
                    {caratData.map((curElem, index) => {
                        return (
                            <button
                                key={index}
                                type="button"
                                name="carat"
                                value={curElem}
                                className={curElem === carat ? "active" : ""}
                                onClick={updateFilterValue}>
                                {curElem}
                            </button>
                        );
                    })}
                </div>
            </div>

            <div className="filter_price mb-2">
                <h3>Price</h3>
                <p>
                    <FormatPrice price={price} />
                </p>
                <input
                    type="range"
                    name="price"
                    min={minPrice}
                    max={maxPrice}
                    value={price}
                    onChange={updateFilterValue}
                />
            </div>

            <div className="filter_price mb-2">

                {/* <div className='range-slider'>
                    <p>{color}</p>
                    <input type="range" list="tickmarks" id="inputRange" step="1" min="0" value={color} max={colorData.length} onChange={updateFilterValue} />
                    <datalist id="tickmarks">
                        {colorData.map((curElem, index) => {
                            return (
                                <>
                                    <option
                                        key={index}
                                        name="color"
                                        data-value={index}
                                        value={curElem}
                                        className="inputRangeDataOpt"
                                    >
                                        {curElem}
                                    </option>
                                </>
                            );
                        })}
                    </datalist>
                </div> */}


                {/* <h3>Shape Range</h3>
                <p>{shapeData}</p>
                {shapeData.map((curElem) => {
                    for(let i=0; i<=shapeData.length;i++){
                        return(<input
                            type = "range"
                            name = "shape"
                            min = { shapeData[0]}
                            max = { shapeData[3]}
                            value = { curElem }
                            step = { shapeData.length }
                            onChange = { updateFilterValue }
                                />)
                    }
                })} */}

                {/* {shapeData.map((curElem, index) => {
                    return (
                        <><p>
                            {curElem}
                        </p>
                            <input
                                type="range"
                                name="shape"
                                min={curElem}
                                max={curElem}
                                value={curElem}
                                step={curElem.length}
                                onChange={updateFilterValue}
                            />
                        </>
                    );
                })} */}

            </div>
        </>
    );
};

export default FilterSection;